import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import {
  renderToolTip,
  VerticalScrollBodyTable,
} from './VerticalScrollBodyTable';
import { ErrorIcon } from '../icons/ErrorIcon';
import {
  getPermittedSourceSection,
  getPermissionNumber,
  getDocumentFileName,
  getLicenseIndustryString,
} from '../../utilities/CompanySaftyLicenseUtil.js';
import { FeedbackIcon } from '../icons/FeedbackIcon';

export const ConstructionPermitTable = ({
  data,
  isCcusMode = false,
  readOnly = false,
  documentCodes,
  bureaux,
  download,
  selectedCcusId,
  onCreate,
  isInvalidOldData,
}) => {
  const [columns, setColumns] = useState();
  const [headerColumn, setHeaderColumns] = useState();

  useEffect(
    () => {
      const headerColumns = [
        { id: 'error', text: '', style: { width: 50, minWidth: 'auto' } },
        {
          id: 'permission_number_r',
          text: '許可番号',
          style: { width: 200 },
          className: 'value-table__permission-number-r',
        },
        {
          id: 'license_update_date',
          text: '許可（更新）年月日',
          style: { width: 160 },
          className: 'value-table__license-update-date',
        },
        {
          id: 'license_limit_date',
          text: '有効期限年月日',
          style: { width: 160 },
          className: 'value-table__license-limit-date',
        },
        {
          id: 'license_industry',
          text: '許可業種',
        },
        { id: 'company_documents', text: '添付書類' },
        { id: 'buttons', text: '', style: { width: 120 } },
      ];

      const bodyColumns = [
        {
          id: 'error',
          render(data) {
            const invalid =
              _.get(data, 'invalid_flag') ||
              _.get(data, 'other_authorized_industry_invalid_flag');
            if (invalid) {
              return <ErrorIcon className='icon--1_4x form-list__error-icon' />;
            }
            if (data.id === selectedCcusId) {
              return (
                <FeedbackIcon
                  className={`ccus-description__icon ${
                    isCcusMode
                      ? 'ccus-description__icon--blue'
                      : 'ccus-description__icon--yellow'
                  }`}
                />
              );
            }
          },
          className: 'value-table__error',
          style: { width: 50, minWidth: 'auto' },
        },
        {
          id: 'permission_number_r',
          render(data) {
            return (
              <React.Fragment>
                <div>{getPermittedSourceSection(data)}</div>
                <div>{getPermissionNumber(data, bureaux)}</div>
              </React.Fragment>
            );
          },
          style: { width: 200 },
          className: 'value-table__permission-number-r',
        },
        {
          id: 'license_update_date',
          valueString: 'license_update_date',
          style: { width: 160 },
          useTooltip: false,
          className: 'value-table__license-update-date',
        },
        {
          id: 'license_limit_date',
          valueString: 'license_limit_date',
          style: { width: 160 },
          className: 'value-table__license-limit-date',
        },
        {
          id: 'license_industry',
          render(data) {
            const licenseIndustry = getLicenseIndustryString(data);
            return renderToolTip(licenseIndustry);
          },
          className: 'value-table__authorized-name',
        },
        {
          id: 'company_documents',
          render(data) {
            return (
              <React.Fragment>
                {_.map(data.company_documents, file => {
                  const id = _.get(file, 'id');
                  return (
                    <button
                      key={id || file.temp_file_key}
                      className={`btn-text ${id ? '' : 'btn--no-action'}`}
                      onClick={e => {
                        e.stopPropagation();
                        id &&
                          _.isFunction(download) &&
                          download(_.get(file, 'id'));
                      }}
                    >
                      {renderToolTip(getDocumentFileName(file, documentCodes))}
                    </button>
                  );
                })}
              </React.Fragment>
            );
          },
        },
        {
          id: 'buttons',
          render(data) {
            if (isCcusMode) {
              return (
                <div className='action-list'>
                  <button
                    className='btn--sm'
                    onClick={() => _.isFunction(onCreate) && onCreate(data)}
                  >
                    転記
                  </button>
                </div>
              );
            }
          },
          style: { width: 120 },
        },
      ];

      const getColumn = data => {
        const columns = [];
        if (selectedCcusId || isInvalidOldData) {
          columns.push(data[0]);
        }

        columns.push(data[1]);
        columns.push(data[2]);
        columns.push(data[3]);
        columns.push(data[4]);

        if (!isCcusMode) {
          columns.push(data[5]);
        }

        if (!readOnly) {
          columns.push(data[6]);
        }
        return columns;
      };

      setColumns(getColumn(bodyColumns));
      setHeaderColumns(getColumn(headerColumns, true));
    },
    [documentCodes, bureaux, selectedCcusId, isCcusMode, isInvalidOldData]
  );

  return (
    <VerticalScrollBodyTable
      headerColumns={headerColumn}
      bodyColumns={columns}
      tableClassName={`construction-industry-permission-table ${
        isCcusMode ? 'ccus-license-table' : ''
      }`}
      emptyDataClassName={readOnly ? '' : 'table__message--attention'}
      bodyStyle={{ maxHeight: 252 }}
      data={data}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/tables/ConstructionPermitTable.jsx